// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEventLineupsGetBody = {
  eventId: string;
};

export type typeEventLineupsGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    eventId: string;
    home: {
      teamId: string;
      players: {
        playerId: string;
        name: string;
        position?: string | null;
        jerseyNumber?: string | null;
        isStarter: boolean;
      }[];
    };
    away: {
      teamId: string;
      players: {
        playerId: string;
        name: string;
        position?: string | null;
        jerseyNumber?: string | null;
        isStarter: boolean;
      }[];
    };
    asOfAt: string;
  };
};

export type typeEventLineupsGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventLineupsGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventLineupsGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEventLineupsGetBody = {
  type: "object",
  properties: { eventId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["eventId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEventLineupsGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEventLineupsGetBody);
  }

  return async function postEventLineupsGet(
    payload: typeEventLineupsGetBody,
  ): Promise<typeEventLineupsGetOutput200 | typeEventLineupsGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEventLineupsGet" failed before calling the network. #ce34c1172125`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#ce34c1172125" },
        },
        data: null,
      } as typeEventLineupsGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/event/lineups-get`,
      httpMethod: "POST",
      options,
    })) as typeEventLineupsGetOutput200 | typeEventLineupsGetOutput400;
  };
}
